export const introduce = {
  text: '持币余额 > 0.01 的地址数量',
  height: 1200,
};
